"use client";

// packages/react/collection/src/collection.tsx
import _defineProperty from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["scope", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { createContextScope } from "@radix-ui/react-context";
import { useComposedRefs } from "@radix-ui/react-compose-refs";
import { Slot } from "@radix-ui/react-slot";
import { jsx } from "react/jsx-runtime";
function createCollection(name) {
  var PROVIDER_NAME = name + "CollectionProvider";
  var _createContextScope = createContextScope(PROVIDER_NAME),
    _createContextScope2 = _slicedToArray(_createContextScope, 2),
    createCollectionContext = _createContextScope2[0],
    createCollectionScope = _createContextScope2[1];
  var _createCollectionCont = createCollectionContext(PROVIDER_NAME, {
      collectionRef: {
        current: null
      },
      itemMap: /* @__PURE__ */new Map()
    }),
    _createCollectionCont2 = _slicedToArray(_createCollectionCont, 2),
    CollectionProviderImpl = _createCollectionCont2[0],
    useCollectionContext = _createCollectionCont2[1];
  var CollectionProvider = function CollectionProvider(props) {
    var scope = props.scope,
      children = props.children;
    var ref = React.useRef(null);
    var itemMap = React.useRef(/* @__PURE__ */new Map()).current;
    return /* @__PURE__ */jsx(CollectionProviderImpl, {
      scope: scope,
      itemMap: itemMap,
      collectionRef: ref,
      children: children
    });
  };
  CollectionProvider.displayName = PROVIDER_NAME;
  var COLLECTION_SLOT_NAME = name + "CollectionSlot";
  var CollectionSlot = React.forwardRef(function (props, forwardedRef) {
    var scope = props.scope,
      children = props.children;
    var context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
    var composedRefs = useComposedRefs(forwardedRef, context.collectionRef);
    return /* @__PURE__ */jsx(Slot, {
      ref: composedRefs,
      children: children
    });
  });
  CollectionSlot.displayName = COLLECTION_SLOT_NAME;
  var ITEM_SLOT_NAME = name + "CollectionItemSlot";
  var ITEM_DATA_ATTR = "data-radix-collection-item";
  var CollectionItemSlot = React.forwardRef(function (props, forwardedRef) {
    var scope = props.scope,
      children = props.children,
      itemData = _objectWithoutProperties(props, _excluded);
    var ref = React.useRef(null);
    var composedRefs = useComposedRefs(forwardedRef, ref);
    var context = useCollectionContext(ITEM_SLOT_NAME, scope);
    React.useEffect(function () {
      context.itemMap.set(ref, _objectSpread({
        ref: ref
      }, itemData));
      return function () {
        return void context.itemMap.delete(ref);
      };
    });
    return /* @__PURE__ */jsx(Slot, _objectSpread(_objectSpread({}, _defineProperty({}, ITEM_DATA_ATTR, "")), {}, {
      ref: composedRefs,
      children: children
    }));
  });
  CollectionItemSlot.displayName = ITEM_SLOT_NAME;
  function useCollection(scope) {
    var context = useCollectionContext(name + "CollectionConsumer", scope);
    var getItems = React.useCallback(function () {
      var collectionNode = context.collectionRef.current;
      if (!collectionNode) return [];
      var orderedNodes = Array.from(collectionNode.querySelectorAll("[".concat(ITEM_DATA_ATTR, "]")));
      var items = Array.from(context.itemMap.values());
      var orderedItems = items.sort(function (a, b) {
        return orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current);
      });
      return orderedItems;
    }, [context.collectionRef, context.itemMap]);
    return getItems;
  }
  return [{
    Provider: CollectionProvider,
    Slot: CollectionSlot,
    ItemSlot: CollectionItemSlot
  }, useCollection, createCollectionScope];
}
export { createCollection };